import script from "./widgetChartBar.vue?vue&type=script&lang=js"
export * from "./widgetChartBar.vue?vue&type=script&lang=js"

import "./widgetChartBar.vue?vue&type=style&index=0&id=b847d2ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b847d2ae"],['__file',"src/components/widgets/widgetChartBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b847d2ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b847d2ae', __exports__)) {
    api.reload('b847d2ae', __exports__)
  }
  
}


export default __exports__